import { useQuery, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import { ONE_HOUR } from '@constants';
import { FullSpeakerData, FullSpeakersResult } from '@common/types/api';

import { fetchSpeakers } from '../useLobbyQueries/queries';

export const useSpeakersQuery = (page = 1, roomId?: number | null) => {
  const queryClient = useQueryClient();
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'br';

  return useQuery<FullSpeakersResult, AxiosError>(
    ['speakers', page, roomId ? { roomId } : undefined, currentLang],
    fetchSpeakers,
    {
      staleTime: ONE_HOUR,
      onSuccess: ({ speakers }) => {
        speakers.map((speaker) =>
          queryClient.setQueryData<FullSpeakerData>(
            ['speaker', speaker.id, currentLang],
            speaker,
          ),
        );
      },
    },
  );
};
